import { Link } from "react-router-dom";
import { Text, Flex, HelpIndicator } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { noneText, container, iconContainer, icon } from "./styles_vanilla.css";

export type ExternalLinkCountCellRendererProps = {
  count: number;
  launchLink: string;
  tooltipContent?: string;
  tooltipId?: string;
  testIdPrefix?: string;
  iconType?: "arrow-up-right-from-square" | "external-link";
};

export const ExternalLinkCountCellRenderer = ({
  count,
  launchLink,
  tooltipContent = "View cases",
  tooltipId = "view-cases-tooltip",
  testIdPrefix = "view-cases",
  iconType = "arrow-up-right-from-square",
}: ExternalLinkCountCellRendererProps) => {
  if (count <= 0) {
    return <Text className={noneText}>None</Text>;
  }

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      className={container}
      data-testid={`${testIdPrefix}-cell-container`}
    >
      <Text>{count}</Text>
      <Flex alignItems="center" className={iconContainer}>
        <HelpIndicator id={tooltipId} placement="top" content={tooltipContent}>
          <Link to={launchLink} target="_blank" data-testid={`${testIdPrefix}-link`}>
            <Icon
              type={iconType}
              variant="outline"
              color={Colors.Primary600}
              className={icon}
              data-testid={`${testIdPrefix}-icon`}
            />
          </Link>
        </HelpIndicator>
      </Flex>
    </Flex>
  );
};
